import { render, staticRenderFns } from "./ModalKits.vue?vue&type=template&id=1b1036c2&scoped=true&"
import script from "./ModalKits.vue?vue&type=script&lang=js&"
export * from "./ModalKits.vue?vue&type=script&lang=js&"
import style0 from "./ModalKits.vue?vue&type=style&index=0&id=1b1036c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1036c2",
  null
  
)

export default component.exports